import React from 'react';

export interface BreakLinesTextsProps {
	components?: string[];
	children: string;
}

const BreakLinesTexts: React.FC<BreakLinesTextsProps> = ({ components = [], children }) => {
	return (
		<>
			{children.split('\n').map((line, i) => {
				const Component = components[i] ? components[i] : React.Fragment;
				return (
					<Component key={i}>
						{line}
						<br />
					</Component>
				);
			})}
		</>
	);
};

export default BreakLinesTexts;
